import { Icon, type IconName, Logo } from '@viaja/design-system';
import type { ReactNode } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useMe } from '../lib/queries';

const TABS: { to: string; label: string; icon: IconName }[] = [
  { to: '/', label: 'Rotas', icon: 'rota' },
  { to: '/viagens', label: 'Viagens', icon: 'mala' },
  { to: '/alertas', label: 'Alertas', icon: 'alerta' },
];

/** Tela principal (abas): logo à esquerda, conta à direita, abas embaixo. */
export function MainScreen({ children }: { children: ReactNode }) {
  const me = useMe();
  const initial = (me.data?.name ?? '?').trim().charAt(0).toUpperCase();
  return (
    <>
      <div className="app-screen">
        <header className="app-top">
          <Link to="/" aria-label="Viaja, Cris! — início">
            <Logo variant="horizontal" height={40} />
          </Link>
          <Link to="/conta" className="app-iconbtn" aria-label="Sua conta">
            <span className="app-avatar" aria-hidden="true">
              {initial}
            </span>
          </Link>
        </header>
        {children}
      </div>
      <TabBar />
    </>
  );
}

/** Tela interna: botão voltar, título curto e ações à direita. `bare` = sem abas embaixo. */
export function SubScreen({
  title,
  back = -1,
  actions,
  bare = false,
  children,
}: {
  title?: string;
  back?: string | -1;
  actions?: ReactNode;
  bare?: boolean;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <>
      <div className={bare ? 'app-screen app-screen--bare' : 'app-screen'}>
        <header className="app-top app-top--sub">
          <button
            type="button"
            className="app-iconbtn"
            aria-label="Voltar"
            onClick={() =>
              back === -1 && window.history.length > 1 ? navigate(-1) : navigate(back === -1 ? '/' : back)
            }
          >
            <Icon name="voltar" size={24} />
          </button>
          {title ? (
            <span className="body-strong app-top-title">{title}</span>
          ) : (
            <span className="app-spacer" />
          )}
          {actions ? <div className="app-top-actions">{actions}</div> : null}
        </header>
        {children}
      </div>
      {bare ? null : <TabBar />}
    </>
  );
}

function TabBar() {
  return (
    <nav className="app-tabbar" aria-label="Navegação principal">
      <div className="app-tabbar-inner">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.to === '/'} className="app-tab">
            <Icon name={t.icon} size={24} />
            {t.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
